import {
  NavItemChildConfig,
  NavItemWithChildren,
} from '@app/components/layout/sidenav/link/NavItemWithChildren';
import { StationIcon } from '@app/components/stations/StationIcon';
import { useHasPermission } from '@app/core/auth/authorization/hooks/useHasPermission';
import { useDefaultStation } from '@app/core/stations/hooks/useDefaultStation';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { defineMessage, useIntl } from 'react-intl';
import { LoggerIcon } from './LoggerIcon';

const panoramaLabelMessage = defineMessage({
  id: 'logger.sidenav.panorama',
  defaultMessage: 'Panorama',
});

const reportesLabelMessage = defineMessage({
  id: 'logger.sidenav.reportes',
  defaultMessage: 'Reportes',
});

/** Users-authz permission for viewing stream quality reports under Logger. */
// FIXME: use consts when exposed by the client
const STREAM_QUALITY_REPORT_VIEW_PERMISSION = 'stream-analysis:stream-quality:report-view';

export function LoggerLinks() {
  const { $t } = useIntl();

  const loggerLabel = $t({
    id: 'logger.navLabel',
    defaultMessage: 'Logger',
  });

  const defaultStation = useDefaultStation();
  const loggerReportsEnabled =
    useFeatureIsOn('app__logger_reports_enabled') &&
    useHasPermission(STREAM_QUALITY_REPORT_VIEW_PERMISSION);

  const children: NavItemChildConfig[] = [
    {
      label: $t(panoramaLabelMessage),
      to: '/logger/status',
    },
    {
      label: defaultStation.name,
      to: `/logger/s/${defaultStation.slug}`,
      icon: <StationIcon fontSize="inherit" />,
    },
  ];

  if (loggerReportsEnabled) {
    children.push({
      label: $t(reportesLabelMessage),
      to: '/logger/reports',
    });
  }

  return (
    <NavItemWithChildren
      root="/logger"
      label={loggerLabel}
      icon={<LoggerIcon />}
      items={children}
    />
  );
}
